<template>
  <div class="container">
    <section class="section">
      <div class="columns">
        <div class="column is-3">
          <navigation></navigation>
        </div>
        <div class="column">
          <breadcrumb />
          <router-view :key="$route.name + ($route.params.id || '')"></router-view>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Navigation from '@/components/Encyclopedia/Navigation.vue';
import Breadcrumb from '@/components/Encyclopedia/Breadcrumb.vue';

export default {
  name: 'Encyclopedia',
  components: {
    Breadcrumb,
    Navigation,
  },
  metaInfo: {
    title: 'Encyclopedia',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Read through the encyclopedia of Odd Giants game to learn how all the different pieces of the game connect together',
      },
      {
        vmid: 'keywords',
        name: 'keywords',
        content: 'encyclopedia, achievements, locations, skills, upgrades, odd, giants, glitch, game, remake, multiplayer, online, mmorpg',
      },
    ],
  },
};
</script>

<style scoped lang="scss">
</style>
